import { navLinks } from '@/mocks/content';

const reviewItems = [
  '先确定你需要的是未删减、高清修复还是国语中字版',
  '优先选择有正规授权的平台观看',
  '用「片名 + 版本词」的组合关键词检索',
  '下载前先看资源标题里的分辨率、语言与字幕',
  '对来源不明的文件与额外安装要求保持警惕',
];

const relatedTopics = ['未删减版与删减版的区别', '高清修复会改变原片色调吗', '国语配音与原声如何选择', '磁力与种子资源的判断方法'];

export default function SiteFooter() {
  return (
    <footer className="w-full bg-orange-100 border-t border-orange-200">
      <div className="w-full px-4 md:px-8 py-12">
        <div className="bg-white border border-orange-200 rounded-xl p-6 mb-10">
          <h2 className="font-heading text-lg font-semibold text-stone-900 flex items-center gap-2">
            <i className="ri-clipboard-line text-orange-500" aria-hidden="true"></i>
            快速回顾：查片前的五条清单
          </h2>
          <ul className="mt-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
            {reviewItems.map((item) => (
              <li key={item} className="flex items-start gap-2 text-sm text-stone-700">
                <i className="ri-checkbox-circle-line text-orange-500 mt-0.5" aria-hidden="true"></i>
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-orange-500 text-white">
                <i className="ri-movie-2-line text-lg" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-lg font-bold text-stone-900">
                蜜桃成熟时<span className="text-orange-500">3D</span>
              </span>
            </div>
            <p className="mt-4 text-sm text-stone-600 leading-relaxed max-w-md">
              本站是一个关于《蜜桃成熟时3D》版本信息的独立导航页，汇总未删减、高清修复、国语中字等版本差异，
              以及在线播放与迅雷下载的查找思路，帮助观众更高效地定位所需资源。
            </p>
          </div>

          <div className="md:col-span-3">
            <h3 className="font-heading text-sm font-semibold text-stone-900">页面分区</h3>
            <ul className="mt-3 space-y-2">
              {navLinks.map((link) => (
                <li key={link.id}>
                  <a
                    href={`#${link.id}`}
                    className="text-sm text-stone-600 hover:text-orange-600 transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h3 className="font-heading text-sm font-semibold text-stone-900">相关话题</h3>
            <ul className="mt-3 space-y-2">
              {relatedTopics.map((topic) => (
                <li key={topic} className="flex items-start gap-2 text-sm text-stone-600">
                  <i className="ri-article-line text-orange-500 mt-0.5" aria-hidden="true"></i>
                  <span>{topic}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-orange-200 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-stone-500 text-center sm:text-left">
            本站仅提供版本信息与检索思路，不存放、不提供任何影片文件。请通过正规授权渠道观看并支持正版。
          </p>
          <p className="text-xs text-stone-500 whitespace-nowrap">
            © {new Date().getFullYear()} 蜜桃成熟时3D 信息导航页
          </p>
        </div>
      </div>
    </footer>
  );
}